module.exports = __webpack_public_path__ + "img/shapecolor_lo.2fd8eb88.jpg";